import ProfileSuggestions from './ProfileSuggestions';
export default ProfileSuggestions;